import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex p-3 border-bottom mb-4 align-items-end fluid-content placeholder-glow"
}
const _hoisted_2 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_event_card_placeholder = _resolveComponent("event-card-placeholder")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.hasTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("h3", { class: "text-uppercase placeholder col-3" }, null, -1),
          _createElementVNode("button", { class: "btn btn-secondary ms-auto disabled placeholder col-1 btn-action" }, null, -1),
          _createElementVNode("button", { class: "btn btn-primary ms-2 disabled placeholder col-1 btn-action" }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (_, ind) => {
        return (_openBlock(), _createBlock(_component_event_card_placeholder, {
          key: ind,
          admin: _ctx.admin
        }, null, 8, ["admin"]))
      }), 128))
    ])
  ], 64))
}